import React from "react";
import { IonIcon } from "@ionic/react";
import { close } from "ionicons/icons";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import formats from "../../utils/formats";
import "./CiaLoginModalContentStyle.css";

export default function CiaLoginModalContent(props) {
    const { closerHandler } = props;

    const { type, id } = useParams();

    const {t} = useTranslation();

    return (
        <div className="cia-login-modal-trigger overflow-auto p-4 flex flex-col gap-4 text-black">
            <div className="sticky top-0">
                <div className="flex flex-row justify-between">
                    <span className="py-1 px-2 rounded-full text-sm bg-mycia-red text-white">{t("ciamodalcontent.span_1")}</span>

                    <button type="button" onClick={closerHandler} className="text-2xl flex items-center justify-center">
                        <IonIcon slot="icon-only" icon={close}></IonIcon>
                    </button>
                </div>
            </div>

            <img src="/assets/login-cta-img.png" alt="login call to action" />

            <p className="text-center">{t("ciamodalcontent.p_1")}<span className="underline font-bold">{t("ciamodalcontent.span_1")}</span>{t("ciamodalcontent.p_2")}</p>

            <a href={formats.loginUrl(type, id)} onClick={closerHandler} className="block cursor-pointer py-3 px-8 rounded-full font-medium border-2 border-mycia-red">{t("ciamodalcontent.a_1")}</a>

            <p className="text-center">
                <a href={`https://login.mycia.it/register?redirect=${encodeURIComponent(formats.mcmUrl(type, id))}`} target="_blank" rel="noreferrer" className="underline text-mycia-red cursor-pointer">{t("ciamodalcontent.a_2")}</a>
            </p>
        </div>
    );
}
